import {useRegionConfig} from '@frontend/hooks/useRegionConfig'
import clsx from 'clsx'
import {FooterContactsExternalLinks} from './FooterContactsExternalLinks'

interface FooterContactsProps {
    className?: string
    externalLinksClassNameVn?: string
}

// Блок с контактами для футера.
export function FooterContacts(props: FooterContactsProps) {

    const {
        className = clsx(
            'm-0 text-center',
            'text-md-end',
            'me-lg-7 text-lg-start'
        ),
        externalLinksClassNameVn,
    } = props

    const regionConfig = useRegionConfig()

    return (
        <ul
            className={clsx(
                'footer-contacts list-unstyled',
                className
            )}
        >
            <li className="lh-sm">
                <a
                    href={'tel:' + regionConfig.contacts.phone.replace(/[^0-9+]/g, '')}
                    className="fw-600 text-decoration-none"
                >
                    {regionConfig.contacts.phone}
                </a>
            </li>
            <li className="lh-sm mt-1 mt-lg-0">
                <a
                    href={'mailto:' + regionConfig.contacts.email}
                    className="fw-600 text-decoration-none"
                >
                    {regionConfig.contacts.email}
                </a>
            </li>
            <FooterContactsExternalLinks
                classNameVn={externalLinksClassNameVn}
            />
        </ul>
    )
}
